import { useDataTypesHooks, useDescribeHooks } from "../../../../../features/data-types"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DetailFieldProps, DetailPanel, FieldType, FieldValue, UIPermission, useGetCrumbs } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { CompanyUserName, useSystemStateHooks } from "../../../../system"
import { useCreditCardHooks } from "../../../hooks/creditCardHooks"
import { CreditCard } from "../../../state/types"

export const CreditCardDetail = () => {
  const { dataType } = useRoutesHooks().parseUrl()
  const creditCard = dataType! as CreditCard

  const { userHasPermission } = useSystemStateHooks()
  const readOnly = !userHasPermission(UIPermission.SAVE_CREDIT_CARDS) || creditCard.archived
  const { describe } = useDescribeHooks()
  const { formatDateTime } = useDataTypesHooks()
  const { describeCreditCard } = useCreditCardHooks()

  const title = describe(TableName.CREDIT_CARDS, creditCard)
  const crumbs = useGetCrumbs('Tarjetas', RoutePath.CREDIT_CARDS, describeCreditCard(creditCard))

  const fields: DetailFieldProps[] = [
    { name: 'type', type: FieldType.TEXT, label: 'Tipo' },
    { name: 'issuer', type: FieldType.TEXT, label: 'Emisor' },
    { name: 'cardholder', type: FieldType.TEXT, label: 'Titular' },
    {
      name: 'last4Numbers',
      type: FieldType.TEXT,
      label: 'Número',
      render: (value?: FieldValue) => <>* - {value}</>
    },
    { name: 'dueDate', type: FieldType.DATE, label: 'Fecha de Vto.' }
  ]

  if (creditCard.negativeStateUserId) {
    fields.push({
      name: 'negativeStateUserId',
      type: FieldType.TEXT,
      label: 'Archivado por',
      render: () => {
        const dateStr = creditCard.negativeStateAt ? ` - ${formatDateTime(new Date(creditCard.negativeStateAt))}` : ''
        return <><CompanyUserName userId={creditCard.negativeStateUserId!} />{dateStr}</>
      }
    })
  }

  return (<>
    <DetailPanel
      title={title}
      tableName={TableName.CREDIT_CARDS}
      crumbs={crumbs}
      fields={fields}
      data={creditCard}
      icon='credit-card'
      readOnly={readOnly}
    />
  </>)
}
